// extracted by mini-css-extract-plugin
export default {"wrapper":"addVersionSlider_wrapper__lamYr","buttonWrapper":"addVersionSlider_buttonWrapper__d+VwA"};